import React from 'react';
import { Typography } from '@mui/material';
import { User } from '@/types/user';
import UsersTable from '@/features/settings/components/UsersTable';

interface InvitedUsersSectionProps {
  invitedUsers: User[];
  onEditUser: (user: User) => void;
  onDeleteUser: (userId: number) => void;
  onDisableUser: (userId: number) => void;
  onInviteUser: (user:User) => void;
}

export const InvitedUsersSection: React.FC<InvitedUsersSectionProps> = ({
  invitedUsers,
  onEditUser,
  onDeleteUser,
  onDisableUser,
  onInviteUser,
}) => {
  if (!invitedUsers.length) return null;

  return (
    <>
      {/* Margins rather than a wrapper's padding: padding indented the heading
          away from the table's left edge, and the section needs more room above
          it than below so the heading groups with its own table. */}
      <Typography variant="subtitle1" sx={{ mt: 5, mb: 3 }}>
        Invites
      </Typography>
      <UsersTable
        invitees={true}
        users={invitedUsers}
        handleEditUserGroup={onEditUser}
        handleDelete={onDeleteUser}
        handleDisable={onDisableUser}
        handleInvite={onInviteUser}
        pageSize={5}
        disabledColumns={['lastSeen', 'name']}
      />
    </>
  );
};
